module.exports = __webpack_public_path__ + "img/coffee_tea.a9a4fbcf.svg";